import { render } from "./MultiCheckbox.vue?vue&type=template&id=6fee5d3e"
import script from "./MultiCheckbox.vue?vue&type=script&lang=js"
export * from "./MultiCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__